<template>
     <Toolbar>
        <template v-slot:left>
            <h5 class="p-m-0">Companies & SMS Sender Ids</h5>
        </template>
    </Toolbar>
     <TabMenu :model="items" />
     <router-view />
</template>

<script>
import TabMenu from 'primevue/tabmenu';
export default {
    components:{TabMenu},
  name: "headerComponent",
  data() {
    return {
        items: [
                {label: 'DLT Companies', icon: 'pi pi-phone', to: '/settings/companies' },
                {label: 'SMS Sender Ids', icon: 'pi pi-users', to: '/settings/sms-sender-ids'},
            ],
    };
  },
};
</script>